import _asyncToGenerator from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _defineProperty from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _createForOfIteratorHelper from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _slicedToArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _toConsumableArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["queryClient", "storage", "persister"],
    _excluded2 = ["address", "chainId", "abi", "functionName"];

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

// src/client.ts
import { createSyncStoragePersister } from "@tanstack/query-sync-storage-persister";
import { QueryClient } from "@tanstack/react-query";
import { persistQueryClient } from "@tanstack/react-query-persist-client";
import { createClient as createCoreClient, createStorage, noopStorage } from "@wagmi/core";

function createClient(_ref) {
  var _ref$queryClient = _ref.queryClient,
      queryClient = _ref$queryClient === void 0 ? new QueryClient({
    defaultOptions: {
      queries: {
        cacheTime: 1e3 * 60 * 60 * 24,
        networkMode: "offlineFirst",
        refetchOnWindowFocus: false,
        retry: 0
      },
      mutations: {
        networkMode: "offlineFirst"
      }
    }
  }) : _ref$queryClient,
      _ref$storage = _ref.storage,
      storage = _ref$storage === void 0 ? createStorage({
    storage: typeof window !== "undefined" && window.localStorage ? window.localStorage : noopStorage
  }) : _ref$storage,
      _ref$persister = _ref.persister,
      persister = _ref$persister === void 0 ? typeof window !== "undefined" ? createSyncStoragePersister({
    key: "cache",
    storage: storage,
    serialize: function serialize(x) {
      return x;
    },
    deserialize: function deserialize(x) {
      return x;
    }
  }) : void 0 : _ref$persister,
      config = _objectWithoutProperties(_ref, _excluded);

  var client = createCoreClient(_objectSpread(_objectSpread({}, config), {}, {
    storage: storage
  }));
  if (persister) persistQueryClient({
    queryClient: queryClient,
    persister: persister,
    dehydrateOptions: {
      shouldDehydrateQuery: function shouldDehydrateQuery(query) {
        return query.cacheTime !== 0 && query.queryKey[0].persist !== false;
      }
    }
  });
  return Object.assign(client, {
    queryClient: queryClient
  });
} // src/context.ts


import { QueryClientProvider } from "@tanstack/react-query";
import * as React from "react";
var Context = React.createContext(void 0);
var queryClientContext = React.createContext(void 0);

function WagmiConfig(_ref2) {
  var children = _ref2.children,
      client = _ref2.client;
  return React.createElement(Context.Provider, {
    children: React.createElement(QueryClientProvider, {
      children: children,
      client: client.queryClient,
      context: queryClientContext
    }),
    value: client
  });
}

function useClient() {
  var client = React.useContext(Context);
  if (!client) throw new Error(["`useClient` must be used within `WagmiConfig`.\n", "Read more: https://wagmi.sh/react/WagmiConfig"].join("\n"));
  return client;
} // src/hooks/accounts/useAccount.ts


import { getAccount, getClient } from "@wagmi/core";
import * as React7 from "react"; // src/hooks/utils/query/useBaseQuery.ts

import { notifyManager, useIsRestoring, useQueryClient, useQueryErrorResetBoundary } from "@tanstack/react-query";
import * as React2 from "react"; // src/hooks/utils/useSyncExternalStore.ts

import * as pkg from "use-sync-external-store/shim/index.js";
var useSyncExternalStore2 = pkg.useSyncExternalStore; // src/hooks/utils/query/utils.ts

function isQueryKey(value) {
  return Array.isArray(value);
}

function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === "function") {
    return _objectSpread(_objectSpread({}, arg3), {}, {
      queryKey: arg1,
      queryFn: arg2
    });
  }

  return _objectSpread(_objectSpread({}, arg2), {}, {
    queryKey: arg1
  });
}

function shouldThrowError(_useErrorBoundary, params) {
  if (typeof _useErrorBoundary === "function") {
    return _useErrorBoundary.apply(void 0, _toConsumableArray(params));
  }

  return !!_useErrorBoundary;
}

function trackResult(result, observer) {
  var trackedResult = {};
  Object.keys(result).forEach(function (key) {
    Object.defineProperty(trackedResult, key, {
      configurable: false,
      enumerable: true,
      get: function get() {
        observer.trackedProps.add(key);
        return result[key];
      }
    });
  });
  return trackedResult;
} // src/hooks/utils/query/useBaseQuery.ts


function useBaseQuery(options, Observer) {
  var queryClient = useQueryClient({
    context: options.context
  });
  var isRestoring = useIsRestoring();
  var errorResetBoundary = useQueryErrorResetBoundary();
  var defaultedOptions = queryClient.defaultQueryOptions(options);
  defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager.batchCalls(defaultedOptions.onSettled);
  }

  if (defaultedOptions.suspense) {
    if (typeof defaultedOptions.staleTime !== "number") {
      defaultedOptions.staleTime = 1e3;
    }
  }

  if (defaultedOptions.suspense || defaultedOptions.useErrorBoundary) {
    if (!errorResetBoundary.isReset()) {
      defaultedOptions.retryOnMount = false;
    }
  }

  var _React2$useState = React2.useState(function () {
    return new Observer(queryClient, defaultedOptions);
  }),
      _React2$useState2 = _slicedToArray(_React2$useState, 1),
      observer = _React2$useState2[0];

  var result = observer.getOptimisticResult(defaultedOptions);
  useSyncExternalStore2(React2.useCallback(function (onStoreChange) {
    return isRestoring ? function () {
      return void 0;
    } : observer.subscribe(notifyManager.batchCalls(onStoreChange));
  }, [observer, isRestoring]), function () {
    return observer.getCurrentResult();
  }, function () {
    return observer.getCurrentResult();
  });
  React2.useEffect(function () {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
  React2.useEffect(function () {
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]);

  if (defaultedOptions.suspense && result.isLoading && result.isFetching && !isRestoring) {
    throw observer.fetchOptimistic(defaultedOptions).then(function (_ref3) {
      var _defaultedOptions$onS, _defaultedOptions$onS2;

      var data = _ref3.data;
      (_defaultedOptions$onS = defaultedOptions.onSuccess) === null || _defaultedOptions$onS === void 0 ? void 0 : _defaultedOptions$onS.call(defaultedOptions, data);
      (_defaultedOptions$onS2 = defaultedOptions.onSettled) === null || _defaultedOptions$onS2 === void 0 ? void 0 : _defaultedOptions$onS2.call(defaultedOptions, data, null);
    }).catch(function (error) {
      var _defaultedOptions$onE, _defaultedOptions$onS3;

      errorResetBoundary.clearReset();
      (_defaultedOptions$onE = defaultedOptions.onError) === null || _defaultedOptions$onE === void 0 ? void 0 : _defaultedOptions$onE.call(defaultedOptions, error);
      (_defaultedOptions$onS3 = defaultedOptions.onSettled) === null || _defaultedOptions$onS3 === void 0 ? void 0 : _defaultedOptions$onS3.call(defaultedOptions, void 0, error);
    });
  }

  if (result.isError && !errorResetBoundary.isReset() && !result.isFetching && shouldThrowError(defaultedOptions.useErrorBoundary, [result.error, observer.getCurrentQuery()])) {
    throw result.error;
  }

  var status = result.status === "loading" && result.fetchStatus === "idle" ? "idle" : result.status;
  var isIdle = status === "idle";
  var isLoading = status === "loading" && result.fetchStatus === "fetching";
  return _objectSpread(_objectSpread({}, result), {}, {
    defaultedOptions: defaultedOptions,
    isIdle: isIdle,
    isLoading: isLoading,
    observer: observer,
    status: status
  });
} // src/hooks/utils/query/useInfiniteQuery.ts


import { InfiniteQueryObserver } from "@tanstack/react-query";

function useInfiniteQuery(arg1, arg2, arg3) {
  var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
  var baseQuery = useBaseQuery(_objectSpread({
    context: queryClientContext
  }, parsedOptions), InfiniteQueryObserver);
  var result = {
    data: baseQuery.data,
    error: baseQuery.error,
    fetchNextPage: baseQuery.fetchNextPage,
    fetchStatus: baseQuery.fetchStatus,
    hasNextPage: baseQuery.hasNextPage,
    isError: baseQuery.isError,
    isFetched: baseQuery.isFetched,
    isFetchedAfterMount: baseQuery.isFetchedAfterMount,
    isFetching: baseQuery.isFetching,
    isFetchingNextPage: baseQuery.isFetchingNextPage,
    isIdle: baseQuery.isIdle,
    isLoading: baseQuery.isLoading,
    isRefetching: baseQuery.isRefetching,
    isSuccess: baseQuery.isSuccess,
    refetch: baseQuery.refetch,
    status: baseQuery.status,
    internal: {
      dataUpdatedAt: baseQuery.dataUpdatedAt,
      errorUpdatedAt: baseQuery.errorUpdatedAt,
      failureCount: baseQuery.failureCount,
      isFetchedAfterMount: baseQuery.isFetchedAfterMount,
      isLoadingError: baseQuery.isLoadingError,
      isPaused: baseQuery.isPaused,
      isPlaceholderData: baseQuery.isPlaceholderData,
      isPreviousData: baseQuery.isPreviousData,
      isRefetchError: baseQuery.isRefetchError,
      isStale: baseQuery.isStale,
      remove: baseQuery.remove
    }
  };
  return !baseQuery.defaultedOptions.notifyOnChangeProps ? trackResult(result, baseQuery.observer) : result;
} // src/hooks/utils/query/useMutation.ts


import { parseMutationArgs, useMutation as useMutation_ } from "@tanstack/react-query";

function useMutation(arg1, arg2, arg3) {
  var options = parseMutationArgs(arg1, arg2, arg3);
  return useMutation_(_objectSpread({
    context: queryClientContext
  }, options));
} // src/hooks/utils/query/useQuery.ts


import { QueryObserver } from "@tanstack/react-query";

function useQuery(arg1, arg2, arg3) {
  var parsedOptions = parseQueryArgs(arg1, arg2, arg3);
  var baseQuery = useBaseQuery(_objectSpread({
    context: queryClientContext
  }, parsedOptions), QueryObserver);
  var result = {
    data: baseQuery.data,
    error: baseQuery.error,
    fetchStatus: baseQuery.fetchStatus,
    isError: baseQuery.isError,
    isFetched: baseQuery.isFetched,
    isFetchedAfterMount: baseQuery.isFetchedAfterMount,
    isFetching: baseQuery.isFetching,
    isIdle: baseQuery.isIdle,
    isLoading: baseQuery.isLoading,
    isRefetching: baseQuery.isRefetching,
    isSuccess: baseQuery.isSuccess,
    refetch: baseQuery.refetch,
    status: baseQuery.status,
    internal: {
      dataUpdatedAt: baseQuery.dataUpdatedAt,
      errorUpdatedAt: baseQuery.errorUpdatedAt,
      failureCount: baseQuery.failureCount,
      isFetchedAfterMount: baseQuery.isFetchedAfterMount,
      isLoadingError: baseQuery.isLoadingError,
      isPaused: baseQuery.isPaused,
      isPlaceholderData: baseQuery.isPlaceholderData,
      isPreviousData: baseQuery.isPreviousData,
      isRefetchError: baseQuery.isRefetchError,
      isStale: baseQuery.isStale,
      remove: baseQuery.remove
    }
  };
  return !baseQuery.defaultedOptions.notifyOnChangeProps ? trackResult(result, baseQuery.observer) : result;
} // src/hooks/utils/query/useQueryClient.ts


import { useQueryClient as useQueryClient_ } from "@tanstack/react-query";

var useQueryClient2 = function useQueryClient2() {
  return useQueryClient_({
    context: queryClientContext
  });
}; // src/hooks/providers/useProvider.ts


import { getProvider, watchProvider } from "@wagmi/core";
import { useSyncExternalStoreWithSelector } from "use-sync-external-store/shim/with-selector.js";

function useProvider() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref4.chainId;

  return useSyncExternalStoreWithSelector(function (cb) {
    return watchProvider({
      chainId: chainId
    }, cb);
  }, function () {
    return getProvider({
      chainId: chainId
    });
  }, function () {
    return getProvider({
      chainId: chainId
    });
  }, function (x) {
    return x;
  }, function (a, b) {
    return a.network.chainId === b.network.chainId;
  });
} // src/hooks/providers/useWebSocketProvider.ts


import { getWebSocketProvider, watchWebSocketProvider } from "@wagmi/core";
import { useSyncExternalStoreWithSelector as useSyncExternalStoreWithSelector2 } from "use-sync-external-store/shim/with-selector.js";

function useWebSocketProvider() {
  var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref5.chainId;

  return useSyncExternalStoreWithSelector2(function (cb) {
    return watchWebSocketProvider({
      chainId: chainId
    }, cb);
  }, function () {
    return getWebSocketProvider({
      chainId: chainId
    });
  }, function () {
    return getWebSocketProvider({
      chainId: chainId
    });
  }, function (x) {
    return x;
  }, function (a, b) {
    return (a === null || a === void 0 ? void 0 : a.network.chainId) === (b === null || b === void 0 ? void 0 : b.network.chainId);
  });
} // src/hooks/utils/useChainId.ts


function useChainId() {
  var _ref6 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref6.chainId;

  var provider = useProvider({
    chainId: chainId
  });
  return provider.network.chainId;
} // src/hooks/utils/useForceUpdate.ts


import * as React3 from "react";

function useForceUpdate() {
  var _React3$useReducer = React3.useReducer(function (x) {
    return x + 1;
  }, 0),
      _React3$useReducer2 = _slicedToArray(_React3$useReducer, 2),
      forceUpdate = _React3$useReducer2[1];

  return forceUpdate;
} // src/hooks/network-status/useBlockNumber.ts


import { fetchBlockNumber } from "@wagmi/core";
import { debounce } from "@wagmi/core/internal";
import * as React4 from "react";

function queryKey(_ref7) {
  var chainId = _ref7.chainId,
      scopeKey = _ref7.scopeKey;
  return [{
    entity: "blockNumber",
    chainId: chainId,
    scopeKey: scopeKey
  }];
}

function queryFn(_ref8) {
  var _ref8$queryKey = _slicedToArray(_ref8.queryKey, 1),
      chainId = _ref8$queryKey[0].chainId;

  return fetchBlockNumber({
    chainId: chainId
  });
}

function useBlockNumber() {
  var _ref9 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref9$cacheTime = _ref9.cacheTime,
      cacheTime = _ref9$cacheTime === void 0 ? 0 : _ref9$cacheTime,
      chainId_ = _ref9.chainId,
      _ref9$enabled = _ref9.enabled,
      enabled = _ref9$enabled === void 0 ? true : _ref9$enabled,
      scopeKey = _ref9.scopeKey,
      staleTime = _ref9.staleTime,
      suspense = _ref9.suspense,
      _ref9$watch = _ref9.watch,
      watch = _ref9$watch === void 0 ? false : _ref9$watch,
      onBlock = _ref9.onBlock,
      onError = _ref9.onError,
      onSettled = _ref9.onSettled,
      onSuccess = _ref9.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  var provider = useProvider({
    chainId: chainId
  });
  var webSocketProvider = useWebSocketProvider({
    chainId: chainId
  });
  var queryClient = useQueryClient2();
  React4.useEffect(function () {
    if (!enabled) return;
    if (!watch && !onBlock) return;
    var listener = debounce(function (blockNumber) {
      if (watch) queryClient.setQueryData(queryKey({
        chainId: chainId,
        scopeKey: scopeKey
      }), blockNumber);
      if (onBlock) onBlock(blockNumber);
    }, 1);
    var provider_ = webSocketProvider !== null && webSocketProvider !== void 0 ? webSocketProvider : provider;
    provider_.on("block", listener);
    return function () {
      provider_.off("block", listener);
    };
  }, [chainId, scopeKey, onBlock, provider, queryClient, watch, webSocketProvider, enabled]);
  return useQuery(queryKey({
    scopeKey: scopeKey,
    chainId: chainId
  }), queryFn, {
    cacheTime: cacheTime,
    enabled: enabled,
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/network-status/useFeeData.ts


import { fetchFeeData } from "@wagmi/core";
import * as React5 from "react";

function queryKey2(_ref10) {
  var chainId = _ref10.chainId,
      formatUnits = _ref10.formatUnits,
      scopeKey = _ref10.scopeKey;
  return [{
    entity: "feeData",
    chainId: chainId,
    formatUnits: formatUnits,
    scopeKey: scopeKey
  }];
}

function queryFn2(_ref11) {
  var _ref11$queryKey = _slicedToArray(_ref11.queryKey, 1),
      _ref11$queryKey$ = _ref11$queryKey[0],
      chainId = _ref11$queryKey$.chainId,
      formatUnits = _ref11$queryKey$.formatUnits;

  return fetchFeeData({
    chainId: chainId,
    formatUnits: formatUnits
  });
}

function useFeeData() {
  var _ref12 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cacheTime = _ref12.cacheTime,
      chainId_ = _ref12.chainId,
      _ref12$enabled = _ref12.enabled,
      enabled = _ref12$enabled === void 0 ? true : _ref12$enabled,
      _ref12$formatUnits = _ref12.formatUnits,
      formatUnits = _ref12$formatUnits === void 0 ? "wei" : _ref12$formatUnits,
      scopeKey = _ref12.scopeKey,
      staleTime = _ref12.staleTime,
      suspense = _ref12.suspense,
      watch = _ref12.watch,
      onError = _ref12.onError,
      onSettled = _ref12.onSettled,
      onSuccess = _ref12.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  var queryKey_ = React5.useMemo(function () {
    return queryKey2({
      chainId: chainId,
      formatUnits: formatUnits,
      scopeKey: scopeKey
    });
  }, [chainId, formatUnits, scopeKey]);
  var feeDataQuery = useQuery(queryKey_, queryFn2, {
    cacheTime: cacheTime,
    enabled: enabled,
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
  useInvalidateOnBlock({
    chainId: chainId,
    enabled: Boolean(enabled && watch),
    queryKey: queryKey_
  });
  return feeDataQuery;
} // src/hooks/utils/useInvalidateOnBlock.ts


function useInvalidateOnBlock(_ref13) {
  var chainId = _ref13.chainId,
      enabled = _ref13.enabled,
      queryKey17 = _ref13.queryKey;
  var queryClient = useQueryClient2();
  useBlockNumber({
    chainId: chainId,
    enabled: enabled,
    onBlock: enabled ? function () {
      return queryClient.invalidateQueries(queryKey17);
    } : void 0,
    scopeKey: enabled ? void 0 : "idle"
  });
} // src/hooks/utils/useSyncExternalStoreWithTracked.ts


import { deepEqual } from "@wagmi/core";
import * as React6 from "react";
import { useSyncExternalStoreWithSelector as useSyncExternalStoreWithSelector3 } from "use-sync-external-store/shim/with-selector.js";

var isPlainObject = function isPlainObject(obj) {
  return typeof obj === "object" && !Array.isArray(obj);
};

function useSyncExternalStoreWithTracked(subscribe, getSnapshot) {
  var getServerSnapshot = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : getSnapshot;
  var isEqual = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : deepEqual;
  var trackedKeys = React6.useRef([]);
  var result = useSyncExternalStoreWithSelector3(subscribe, getSnapshot, getServerSnapshot, function (x) {
    return x;
  }, function (a, b) {
    if (isPlainObject(a) && isPlainObject(b) && trackedKeys.current.length) {
      var _iterator = _createForOfIteratorHelper(trackedKeys.current),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var key = _step.value;
          var equal = isEqual(a[key], b[key]);
          if (!equal) return false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return true;
    }

    return isEqual(a, b);
  });

  if (isPlainObject(result)) {
    var trackedResult = _objectSpread({}, result);

    Object.defineProperties(trackedResult, Object.entries(trackedResult).reduce(function (res, _ref14) {
      var _ref15 = _slicedToArray(_ref14, 2),
          key = _ref15[0],
          value = _ref15[1];

      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, key, {
        configurable: false,
        enumerable: true,
        get: function get() {
          if (!trackedKeys.current.includes(key)) {
            trackedKeys.current.push(key);
          }

          return value;
        }
      }));
    }, {}));
    return trackedResult;
  }

  return result;
} // src/hooks/accounts/useAccount.ts


function useAccount() {
  var _ref16 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onConnect = _ref16.onConnect,
      onDisconnect = _ref16.onDisconnect;

  var watchAccount = React7.useCallback(function (callback) {
    var client = getClient();
    var unsubscribe = client.subscribe(function (state) {
      var _state$data;

      return {
        address: (_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data.account,
        connector: state.connector,
        status: state.status
      };
    }, function (curr, prev) {
      if (!!onConnect && prev.status !== "connected" && curr.status === "connected") onConnect({
        address: curr.address,
        connector: curr.connector,
        isReconnected: prev.status === "reconnecting"
      });
      if (!!onDisconnect && prev.status === "connected" && curr.status === "disconnected") onDisconnect();
      return callback(getAccount());
    });
    return unsubscribe;
  }, [onConnect, onDisconnect]);
  var account = useSyncExternalStoreWithTracked(watchAccount, getAccount);
  var previousStatusRef = React7.useRef();
  var address = account.address,
      connector = account.connector,
      status = account.status;
  React7.useEffect(function () {
    if (!!onConnect && previousStatusRef.current === void 0 && status === "connected") onConnect({
      address: address,
      connector: connector,
      isReconnected: true
    });
    previousStatusRef.current = status;
  }, []);
  return account;
} // src/hooks/accounts/useBalance.ts


import { fetchBalance } from "@wagmi/core";
import * as React8 from "react";

function queryKey3(_ref17) {
  var address = _ref17.address,
      chainId = _ref17.chainId,
      formatUnits = _ref17.formatUnits,
      scopeKey = _ref17.scopeKey,
      token = _ref17.token;
  return [{
    entity: "balance",
    address: address,
    chainId: chainId,
    formatUnits: formatUnits,
    scopeKey: scopeKey,
    token: token
  }];
}

function queryFn3(_ref18) {
  var _ref18$queryKey = _slicedToArray(_ref18.queryKey, 1),
      _ref18$queryKey$ = _ref18$queryKey[0],
      address = _ref18$queryKey$.address,
      chainId = _ref18$queryKey$.chainId,
      formatUnits = _ref18$queryKey$.formatUnits,
      token = _ref18$queryKey$.token;

  if (!address) throw new Error("address is required");
  return fetchBalance({
    address: address,
    chainId: chainId,
    formatUnits: formatUnits,
    token: token
  });
}

function useBalance() {
  var _ref19 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref19.address,
      cacheTime = _ref19.cacheTime,
      chainId_ = _ref19.chainId,
      _ref19$enabled = _ref19.enabled,
      enabled = _ref19$enabled === void 0 ? true : _ref19$enabled,
      formatUnits = _ref19.formatUnits,
      scopeKey = _ref19.scopeKey,
      staleTime = _ref19.staleTime,
      suspense = _ref19.suspense,
      token = _ref19.token,
      watch = _ref19.watch,
      onError = _ref19.onError,
      onSettled = _ref19.onSettled,
      onSuccess = _ref19.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  var queryKey_ = React8.useMemo(function () {
    return queryKey3({
      address: address,
      chainId: chainId,
      formatUnits: formatUnits,
      scopeKey: scopeKey,
      token: token
    });
  }, [address, chainId, formatUnits, scopeKey, token]);
  var balanceQuery = useQuery(queryKey_, queryFn3, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && address),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
  useInvalidateOnBlock({
    chainId: chainId,
    enabled: Boolean(enabled && watch && address),
    queryKey: queryKey_
  });
  return balanceQuery;
} // src/hooks/accounts/useConnect.ts


import { connect } from "@wagmi/core";
import * as React9 from "react";

var mutationKey = function mutationKey(args) {
  return [_objectSpread({
    entity: "connect"
  }, args)];
};

var mutationFn = function mutationFn(args) {
  var connector = args.connector,
      chainId = args.chainId;
  if (!connector) throw new Error("connector is required");
  return connect({
    connector: connector,
    chainId: chainId
  });
};

function useConnect() {
  var _ref20 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref20.chainId,
      connector = _ref20.connector,
      onError = _ref20.onError,
      onMutate = _ref20.onMutate,
      onSettled = _ref20.onSettled,
      onSuccess = _ref20.onSuccess;

  var client = useClient();

  var _useMutation = useMutation(mutationKey({
    connector: connector,
    chainId: chainId
  }), mutationFn, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation.data,
      error = _useMutation.error,
      isError = _useMutation.isError,
      isIdle = _useMutation.isIdle,
      isLoading = _useMutation.isLoading,
      isSuccess = _useMutation.isSuccess,
      mutate = _useMutation.mutate,
      mutateAsync = _useMutation.mutateAsync,
      reset = _useMutation.reset,
      status = _useMutation.status,
      variables = _useMutation.variables;

  var connect2 = React9.useCallback(function (args) {
    var _args$chainId, _args$connector;

    return mutate({
      chainId: (_args$chainId = args === null || args === void 0 ? void 0 : args.chainId) !== null && _args$chainId !== void 0 ? _args$chainId : chainId,
      connector: (_args$connector = args === null || args === void 0 ? void 0 : args.connector) !== null && _args$connector !== void 0 ? _args$connector : connector
    });
  }, [chainId, connector, mutate]);
  var connectAsync = React9.useCallback(function (args) {
    var _args$chainId2, _args$connector2;

    return mutateAsync({
      chainId: (_args$chainId2 = args === null || args === void 0 ? void 0 : args.chainId) !== null && _args$chainId2 !== void 0 ? _args$chainId2 : chainId,
      connector: (_args$connector2 = args === null || args === void 0 ? void 0 : args.connector) !== null && _args$connector2 !== void 0 ? _args$connector2 : connector
    });
  }, [chainId, connector, mutateAsync]);
  return {
    connect: connect2,
    connectAsync: connectAsync,
    connectors: client.connectors,
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    pendingConnector: variables === null || variables === void 0 ? void 0 : variables.connector,
    reset: reset,
    status: status,
    variables: variables
  };
} // src/hooks/accounts/useDisconnect.ts


import { disconnect } from "@wagmi/core";
var mutationKey2 = [{
  entity: "disconnect"
}];

var mutationFn2 = function mutationFn2() {
  return disconnect();
};

function useDisconnect() {
  var _ref21 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _onError = _ref21.onError,
      onMutate = _ref21.onMutate,
      _onSettled = _ref21.onSettled,
      _onSuccess = _ref21.onSuccess;

  var _useMutation2 = useMutation(mutationKey2, mutationFn2, _objectSpread(_objectSpread(_objectSpread({}, _onError ? {
    onError: function onError(error2, _variables, context) {
      _onError(error2, context);
    }
  } : {}), {}, {
    onMutate: onMutate
  }, _onSettled ? {
    onSettled: function onSettled(_data, error2, _variables, context) {
      _onSettled(error2, context);
    }
  } : {}), _onSuccess ? {
    onSuccess: function onSuccess(_data, _variables, context) {
      _onSuccess(context);
    }
  } : {})),
      error = _useMutation2.error,
      isError = _useMutation2.isError,
      isIdle = _useMutation2.isIdle,
      isLoading = _useMutation2.isLoading,
      isSuccess = _useMutation2.isSuccess,
      disconnect2 = _useMutation2.mutate,
      disconnectAsync = _useMutation2.mutateAsync,
      reset = _useMutation2.reset,
      status = _useMutation2.status;

  return {
    disconnect: disconnect2,
    disconnectAsync: disconnectAsync,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    status: status
  };
} // src/hooks/accounts/useNetwork.ts


import { getNetwork, watchNetwork } from "@wagmi/core";

function useNetwork() {
  return useSyncExternalStoreWithTracked(watchNetwork, getNetwork);
} // src/hooks/accounts/useSigner.ts


import { fetchSigner, watchSigner } from "@wagmi/core";
import * as React10 from "react";

function queryKey4(_ref22) {
  var chainId = _ref22.chainId;
  return [{
    entity: "signer",
    chainId: chainId,
    persist: false
  }];
}

function queryFn4(_ref23) {
  var _ref23$queryKey = _slicedToArray(_ref23.queryKey, 1),
      chainId = _ref23$queryKey[0].chainId;

  return fetchSigner({
    chainId: chainId
  });
}

function useSigner() {
  var _ref24 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId_ = _ref24.chainId,
      suspense = _ref24.suspense,
      onError = _ref24.onError,
      onSettled = _ref24.onSettled,
      onSuccess = _ref24.onSuccess;

  var _useAccount = useAccount(),
      connector = _useAccount.connector;

  var chainId = useChainId({
    chainId: chainId_
  });
  var signerQuery = useQuery(queryKey4({
    chainId: chainId
  }), queryFn4, {
    cacheTime: 0,
    enabled: Boolean(connector),
    staleTime: Infinity,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
  var queryClient = useQueryClient2();
  React10.useEffect(function () {
    var unwatch = watchSigner({
      chainId: chainId
    }, function (signer) {
      if (signer) queryClient.invalidateQueries(queryKey4({
        chainId: chainId
      }));else queryClient.removeQueries(queryKey4({
        chainId: chainId
      }));
    });
    return unwatch;
  }, [queryClient, chainId]);
  return signerQuery;
} // src/hooks/accounts/useSignMessage.ts


import { signMessage } from "@wagmi/core";
import * as React11 from "react";

var mutationKey3 = function mutationKey3(args) {
  return [_objectSpread({
    entity: "signMessage"
  }, args)];
};

var mutationFn3 = function mutationFn3(args) {
  var message = args.message;
  if (!message) throw new Error("message is required");
  return signMessage({
    message: message
  });
};

function useSignMessage() {
  var _ref25 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref25.message,
      onError = _ref25.onError,
      onMutate = _ref25.onMutate,
      onSettled = _ref25.onSettled,
      onSuccess = _ref25.onSuccess;

  var _useMutation3 = useMutation(mutationKey3({
    message: message
  }), mutationFn3, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation3.data,
      error = _useMutation3.error,
      isError = _useMutation3.isError,
      isIdle = _useMutation3.isIdle,
      isLoading = _useMutation3.isLoading,
      isSuccess = _useMutation3.isSuccess,
      mutate = _useMutation3.mutate,
      mutateAsync = _useMutation3.mutateAsync,
      reset = _useMutation3.reset,
      status = _useMutation3.status,
      variables = _useMutation3.variables;

  var signMessage2 = React11.useCallback(function (args) {
    return mutate(args || {
      message: message
    });
  }, [message, mutate]);
  var signMessageAsync = React11.useCallback(function (args) {
    return mutateAsync(args || {
      message: message
    });
  }, [message, mutateAsync]);
  return {
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    signMessage: signMessage2,
    signMessageAsync: signMessageAsync,
    status: status,
    variables: variables
  };
} // src/hooks/accounts/useSignTypedData.ts


import { signTypedData } from "@wagmi/core";
import * as React12 from "react";

function mutationKey4(_ref26) {
  var domain = _ref26.domain,
      types = _ref26.types,
      value = _ref26.value;
  return [{
    entity: "signTypedData",
    domain: domain,
    types: types,
    value: value
  }];
}

function mutationFn4(args) {
  var domain = args.domain,
      types = args.types,
      value = args.value;
  if (!domain) throw new Error("domain is required");
  if (!types) throw new Error("types is required");
  if (!value) throw new Error("value is required");
  return signTypedData({
    domain: domain,
    types: types,
    value: value
  });
}

function useSignTypedData() {
  var _ref27 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      domain = _ref27.domain,
      types = _ref27.types,
      value = _ref27.value,
      onError = _ref27.onError,
      onMutate = _ref27.onMutate,
      onSettled = _ref27.onSettled,
      onSuccess = _ref27.onSuccess;

  var _useMutation4 = useMutation(mutationKey4({
    domain: domain,
    types: types,
    value: value
  }), mutationFn4, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation4.data,
      error = _useMutation4.error,
      isError = _useMutation4.isError,
      isIdle = _useMutation4.isIdle,
      isLoading = _useMutation4.isLoading,
      isSuccess = _useMutation4.isSuccess,
      mutate = _useMutation4.mutate,
      mutateAsync = _useMutation4.mutateAsync,
      reset = _useMutation4.reset,
      status = _useMutation4.status,
      variables = _useMutation4.variables;

  var signTypedData2 = React12.useCallback(function (args) {
    var _args$domain, _args$types, _args$value;

    return mutate({
      domain: (_args$domain = args === null || args === void 0 ? void 0 : args.domain) !== null && _args$domain !== void 0 ? _args$domain : domain,
      types: (_args$types = args === null || args === void 0 ? void 0 : args.types) !== null && _args$types !== void 0 ? _args$types : types,
      value: (_args$value = args === null || args === void 0 ? void 0 : args.value) !== null && _args$value !== void 0 ? _args$value : value
    });
  }, [domain, types, value, mutate]);
  var signTypedDataAsync = React12.useCallback(function (args) {
    var _args$domain2, _args$types2, _args$value2;

    return mutateAsync({
      domain: (_args$domain2 = args === null || args === void 0 ? void 0 : args.domain) !== null && _args$domain2 !== void 0 ? _args$domain2 : domain,
      types: (_args$types2 = args === null || args === void 0 ? void 0 : args.types) !== null && _args$types2 !== void 0 ? _args$types2 : types,
      value: (_args$value2 = args === null || args === void 0 ? void 0 : args.value) !== null && _args$value2 !== void 0 ? _args$value2 : value
    });
  }, [domain, types, value, mutateAsync]);
  return {
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    signTypedData: signTypedData2,
    signTypedDataAsync: signTypedDataAsync,
    status: status,
    variables: variables
  };
} // src/hooks/accounts/useSwitchNetwork.ts


import { switchNetwork } from "@wagmi/core";
import * as React13 from "react";

var mutationKey5 = function mutationKey5(args) {
  return [_objectSpread({
    entity: "switchNetwork"
  }, args)];
};

var mutationFn5 = function mutationFn5(args) {
  var chainId = args.chainId;
  if (!chainId) throw new Error("chainId is required");
  return switchNetwork({
    chainId: chainId
  });
};

function useSwitchNetwork() {
  var _client$connector, _client$chains;

  var _ref28 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref28.chainId,
      throwForSwitchChainNotSupported = _ref28.throwForSwitchChainNotSupported,
      onError = _ref28.onError,
      onMutate = _ref28.onMutate,
      onSettled = _ref28.onSettled,
      onSuccess = _ref28.onSuccess;

  var client = useClient();
  var forceUpdate = useForceUpdate();

  var _useMutation5 = useMutation(mutationKey5({
    chainId: chainId
  }), mutationFn5, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation5.data,
      error = _useMutation5.error,
      isError = _useMutation5.isError,
      isIdle = _useMutation5.isIdle,
      isLoading = _useMutation5.isLoading,
      isSuccess = _useMutation5.isSuccess,
      mutate = _useMutation5.mutate,
      mutateAsync = _useMutation5.mutateAsync,
      reset = _useMutation5.reset,
      status = _useMutation5.status,
      variables = _useMutation5.variables;

  var switchNetwork_ = React13.useCallback(function (chainId_) {
    return mutate({
      chainId: chainId_ !== null && chainId_ !== void 0 ? chainId_ : chainId
    });
  }, [chainId, mutate]);
  var switchNetworkAsync_ = React13.useCallback(function (chainId_) {
    return mutateAsync({
      chainId: chainId_ !== null && chainId_ !== void 0 ? chainId_ : chainId
    });
  }, [chainId, mutateAsync]);
  React13.useEffect(function () {
    var unwatch = client.subscribe(function (_ref29) {
      var chains = _ref29.chains,
          connector = _ref29.connector;
      return {
        chains: chains,
        connector: connector
      };
    }, forceUpdate);
    return unwatch;
  }, [client, forceUpdate]);
  var switchNetwork2;
  var switchNetworkAsync;
  var supportsSwitchChain = !!((_client$connector = client.connector) === null || _client$connector === void 0 ? void 0 : _client$connector.switchChain);

  if (throwForSwitchChainNotSupported || supportsSwitchChain) {
    switchNetwork2 = switchNetwork_;
    switchNetworkAsync = switchNetworkAsync_;
  }

  return {
    chains: (_client$chains = client.chains) !== null && _client$chains !== void 0 ? _client$chains : [],
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    pendingChainId: variables === null || variables === void 0 ? void 0 : variables.chainId,
    reset: reset,
    status: status,
    switchNetwork: switchNetwork2,
    switchNetworkAsync: switchNetworkAsync,
    variables: variables
  };
} // src/hooks/contracts/useContract.ts


import { getContract } from "@wagmi/core";
import * as React14 from "react";

function useContract() {
  var _ref30 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref30.address,
      abi = _ref30.abi,
      signerOrProvider = _ref30.signerOrProvider;

  return React14.useMemo(function () {
    if (!address || !abi) return null;
    return getContract({
      address: address,
      abi: abi,
      signerOrProvider: signerOrProvider === null ? void 0 : signerOrProvider
    });
  }, [address, abi, signerOrProvider]);
} // src/hooks/contracts/useContractEvent.ts


import * as React15 from "react";

function useContractEvent() {
  var _ref31 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref31.address,
      chainId = _ref31.chainId,
      abi = _ref31.abi,
      listener = _ref31.listener,
      eventName = _ref31.eventName,
      once = _ref31.once;

  var provider = useProvider({
    chainId: chainId
  });
  var webSocketProvider = useWebSocketProvider({
    chainId: chainId
  });
  var contract = useContract({
    address: address,
    abi: abi,
    signerOrProvider: webSocketProvider !== null && webSocketProvider !== void 0 ? webSocketProvider : provider
  });
  var callbackRef = React15.useRef(listener);
  callbackRef.current = listener;
  React15.useEffect(function () {
    if (!contract || !eventName) return;

    var handler = function handler() {
      return callbackRef.current.apply(callbackRef, arguments);
    };

    if (once) contract.once(eventName, handler);else contract.on(eventName, handler);
    return function () {
      contract.off(eventName, handler);
    };
  }, [contract, eventName]);
} // src/hooks/contracts/useContractInfiniteReads.ts


import { replaceEqualDeep } from "@tanstack/react-query";
import { deepEqual as deepEqual2, readContracts } from "@wagmi/core";
import * as React16 from "react";

function queryKey5(_ref32) {
  var allowFailure = _ref32.allowFailure,
      cacheKey = _ref32.cacheKey,
      overrides = _ref32.overrides,
      scopeKey = _ref32.scopeKey;
  return [{
    entity: "readContractsInfinite",
    allowFailure: allowFailure,
    cacheKey: cacheKey,
    overrides: overrides,
    scopeKey: scopeKey
  }];
}

function queryFn5(_ref33) {
  var contracts = _ref33.contracts;
  return function (_ref34) {
    var _ref34$queryKey = _slicedToArray(_ref34.queryKey, 1),
        _ref34$queryKey$ = _ref34$queryKey[0],
        allowFailure = _ref34$queryKey$.allowFailure,
        overrides = _ref34$queryKey$.overrides,
        pageParam = _ref34.pageParam;

    return readContracts({
      allowFailure: allowFailure,
      contracts: contracts(pageParam || void 0),
      overrides: overrides
    });
  };
}

function useContractInfiniteReads(_ref35) {
  var allowFailure = _ref35.allowFailure,
      cacheKey = _ref35.cacheKey,
      cacheTime = _ref35.cacheTime,
      contracts = _ref35.contracts,
      _ref35$enabled = _ref35.enabled,
      enabled_ = _ref35$enabled === void 0 ? true : _ref35$enabled,
      getNextPageParam = _ref35.getNextPageParam,
      isDataEqual = _ref35.isDataEqual,
      keepPreviousData = _ref35.keepPreviousData,
      onError = _ref35.onError,
      onSettled = _ref35.onSettled,
      onSuccess = _ref35.onSuccess,
      overrides = _ref35.overrides,
      scopeKey = _ref35.scopeKey,
      select = _ref35.select,
      staleTime = _ref35.staleTime,
      _ref35$structuralShar = _ref35.structuralSharing,
      structuralSharing = _ref35$structuralShar === void 0 ? function (oldData, newData) {
    return deepEqual2(oldData, newData) ? oldData : replaceEqualDeep(oldData, newData);
  } : _ref35$structuralShar,
      suspense = _ref35.suspense;
  var queryKey_ = React16.useMemo(function () {
    return queryKey5({
      allowFailure: allowFailure,
      cacheKey: cacheKey,
      overrides: overrides,
      scopeKey: scopeKey
    });
  }, [allowFailure, cacheKey, overrides, scopeKey]);
  var enabled = React16.useMemo(function () {
    var enabled2 = Boolean(enabled_ && contracts);
    return enabled2;
  }, [contracts, enabled_]);
  return useInfiniteQuery(queryKey_, queryFn5({
    contracts: contracts
  }), {
    cacheTime: cacheTime,
    enabled: enabled,
    getNextPageParam: getNextPageParam,
    isDataEqual: isDataEqual,
    keepPreviousData: keepPreviousData,
    select: select,
    staleTime: staleTime,
    structuralSharing: structuralSharing,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
}

function paginatedIndexesConfig(fn, _ref36) {
  var perPage = _ref36.perPage,
      start = _ref36.start,
      direction = _ref36.direction;

  var contracts = function contracts() {
    var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    return _toConsumableArray(Array(perPage).keys()).map(function (index) {
      return direction === "increment" ? start + index + page * perPage : start - index - page * perPage;
    }).filter(function (index) {
      return index >= 0;
    }).map(fn).flat();
  };

  return {
    contracts: contracts,
    getNextPageParam: function getNextPageParam(lastPage, pages) {
      return (lastPage === null || lastPage === void 0 ? void 0 : lastPage.length) === perPage ? pages.length : void 0;
    }
  };
} // src/hooks/contracts/useContractRead.ts


import { replaceEqualDeep as replaceEqualDeep2 } from "@tanstack/react-query";
import { deepEqual as deepEqual3, parseContractResult, readContract } from "@wagmi/core";
import * as React17 from "react";

function queryKey6(_ref37) {
  var address = _ref37.address,
      args = _ref37.args,
      blockNumber = _ref37.blockNumber,
      chainId = _ref37.chainId,
      functionName = _ref37.functionName,
      overrides = _ref37.overrides,
      scopeKey = _ref37.scopeKey;
  return [{
    entity: "readContract",
    address: address,
    args: args,
    blockNumber: blockNumber,
    chainId: chainId,
    functionName: functionName,
    overrides: overrides,
    scopeKey: scopeKey
  }];
}

function queryFn6(_ref38) {
  var abi = _ref38.abi;
  return /*#__PURE__*/function () {
    var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref39) {
      var _yield$readContract;

      var _ref39$queryKey, _ref39$queryKey$, address, args, chainId, functionName, overrides;

      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref39$queryKey = _slicedToArray(_ref39.queryKey, 1), _ref39$queryKey$ = _ref39$queryKey[0], address = _ref39$queryKey$.address, args = _ref39$queryKey$.args, chainId = _ref39$queryKey$.chainId, functionName = _ref39$queryKey$.functionName, overrides = _ref39$queryKey$.overrides;

              if (abi) {
                _context.next = 3;
                break;
              }

              throw new Error("abi is required");

            case 3:
              if (address) {
                _context.next = 5;
                break;
              }

              throw new Error("address is required");

            case 5:
              _context.next = 7;
              return readContract({
                address: address,
                args: args,
                chainId: chainId,
                abi: abi,
                functionName: functionName,
                overrides: overrides
              });

            case 7:
              _context.t1 = _yield$readContract = _context.sent;
              _context.t0 = _context.t1 !== null;

              if (!_context.t0) {
                _context.next = 11;
                break;
              }

              _context.t0 = _yield$readContract !== void 0;

            case 11:
              if (!_context.t0) {
                _context.next = 15;
                break;
              }

              _context.t2 = _yield$readContract;
              _context.next = 16;
              break;

            case 15:
              _context.t2 = null;

            case 16:
              return _context.abrupt("return", _context.t2);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref40.apply(this, arguments);
    };
  }();
}

function useContractRead() {
  var _ref41 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      abi = _ref41.abi,
      address = _ref41.address,
      args = _ref41.args,
      _ref41$cacheOnBlock = _ref41.cacheOnBlock,
      cacheOnBlock = _ref41$cacheOnBlock === void 0 ? false : _ref41$cacheOnBlock,
      cacheTime = _ref41.cacheTime,
      chainId_ = _ref41.chainId,
      _ref41$enabled = _ref41.enabled,
      enabled_ = _ref41$enabled === void 0 ? true : _ref41$enabled,
      functionName = _ref41.functionName,
      isDataEqual = _ref41.isDataEqual,
      onError = _ref41.onError,
      onSettled = _ref41.onSettled,
      onSuccess = _ref41.onSuccess,
      overrides = _ref41.overrides,
      scopeKey = _ref41.scopeKey,
      _select = _ref41.select,
      staleTime = _ref41.staleTime,
      _ref41$structuralShar = _ref41.structuralSharing,
      structuralSharing = _ref41$structuralShar === void 0 ? function (oldData, newData) {
    return deepEqual3(oldData, newData) ? oldData : replaceEqualDeep2(oldData, newData);
  } : _ref41$structuralShar,
      suspense = _ref41.suspense,
      watch = _ref41.watch;

  var chainId = useChainId({
    chainId: chainId_
  });

  var _useBlockNumber = useBlockNumber({
    chainId: chainId,
    enabled: watch || cacheOnBlock,
    scopeKey: watch || cacheOnBlock ? void 0 : "idle",
    watch: watch
  }),
      blockNumber = _useBlockNumber.data;

  var queryKey_ = React17.useMemo(function () {
    return queryKey6({
      address: address,
      args: args,
      blockNumber: cacheOnBlock ? blockNumber : void 0,
      chainId: chainId,
      functionName: functionName,
      overrides: overrides,
      scopeKey: scopeKey
    });
  }, [address, args, blockNumber, cacheOnBlock, chainId, functionName, overrides, scopeKey]);
  var enabled = React17.useMemo(function () {
    var enabled2 = Boolean(enabled_ && abi && address && functionName);
    if (cacheOnBlock) enabled2 = Boolean(enabled2 && blockNumber);
    return enabled2;
  }, [abi, address, blockNumber, cacheOnBlock, enabled_, functionName]);
  useInvalidateOnBlock({
    chainId: chainId,
    enabled: Boolean(enabled && watch && !cacheOnBlock),
    queryKey: queryKey_
  });
  return useQuery(queryKey_, queryFn6({
    abi: abi
  }), {
    cacheTime: cacheTime,
    enabled: enabled,
    isDataEqual: isDataEqual,
    select: function select(data) {
      var result = abi && functionName ? parseContractResult({
        abi: abi,
        data: data,
        functionName: functionName
      }) : data;
      return _select ? _select(result) : result;
    },
    staleTime: staleTime,
    structuralSharing: structuralSharing,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/contracts/useContractReads.ts


import { replaceEqualDeep as replaceEqualDeep3 } from "@tanstack/react-query";
import { deepEqual as deepEqual4, parseContractResult as parseContractResult2, readContracts as readContracts2 } from "@wagmi/core";
import * as React18 from "react";

function queryKey7(_ref42) {
  var allowFailure = _ref42.allowFailure,
      blockNumber = _ref42.blockNumber,
      chainId = _ref42.chainId,
      contracts = _ref42.contracts,
      overrides = _ref42.overrides,
      scopeKey = _ref42.scopeKey;
  return [{
    entity: "readContracts",
    allowFailure: allowFailure,
    blockNumber: blockNumber,
    chainId: chainId,
    scopeKey: scopeKey,
    contracts: (contracts !== null && contracts !== void 0 ? contracts : []).map(function (_ref43) {
      var address = _ref43.address,
          args = _ref43.args,
          chainId2 = _ref43.chainId,
          functionName = _ref43.functionName;
      return {
        address: address,
        args: args,
        chainId: chainId2,
        functionName: functionName
      };
    }),
    overrides: overrides
  }];
}

function queryFn7(_ref44) {
  var abis = _ref44.abis;
  return function (_ref45) {
    var _ref45$queryKey = _slicedToArray(_ref45.queryKey, 1),
        _ref45$queryKey$ = _ref45$queryKey[0],
        allowFailure = _ref45$queryKey$.allowFailure,
        contracts_ = _ref45$queryKey$.contracts,
        overrides = _ref45$queryKey$.overrides;

    var contracts = contracts_.map(function (contract, i) {
      return _objectSpread(_objectSpread({}, contract), {}, {
        abi: abis[i]
      });
    });
    return readContracts2({
      allowFailure: allowFailure,
      contracts: contracts,
      overrides: overrides
    });
  };
}

function useContractReads() {
  var _ref46 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref46$allowFailure = _ref46.allowFailure,
      allowFailure = _ref46$allowFailure === void 0 ? true : _ref46$allowFailure,
      _ref46$cacheOnBlock = _ref46.cacheOnBlock,
      cacheOnBlock = _ref46$cacheOnBlock === void 0 ? false : _ref46$cacheOnBlock,
      cacheTime = _ref46.cacheTime,
      contracts = _ref46.contracts,
      _ref46$enabled = _ref46.enabled,
      enabled_ = _ref46$enabled === void 0 ? true : _ref46$enabled,
      isDataEqual = _ref46.isDataEqual,
      keepPreviousData = _ref46.keepPreviousData,
      onError = _ref46.onError,
      onSettled = _ref46.onSettled,
      onSuccess = _ref46.onSuccess,
      overrides = _ref46.overrides,
      scopeKey = _ref46.scopeKey,
      _select2 = _ref46.select,
      staleTime = _ref46.staleTime,
      _ref46$structuralShar = _ref46.structuralSharing,
      structuralSharing = _ref46$structuralShar === void 0 ? function (oldData, newData) {
    return deepEqual4(oldData, newData) ? oldData : replaceEqualDeep3(oldData, newData);
  } : _ref46$structuralShar,
      suspense = _ref46.suspense,
      watch = _ref46.watch;

  var _useBlockNumber2 = useBlockNumber({
    enabled: watch || cacheOnBlock,
    watch: watch
  }),
      blockNumber = _useBlockNumber2.data;

  var chainId = useChainId();
  var queryKey_ = React18.useMemo(function () {
    return queryKey7({
      allowFailure: allowFailure,
      blockNumber: cacheOnBlock ? blockNumber : void 0,
      chainId: chainId,
      contracts: contracts,
      overrides: overrides,
      scopeKey: scopeKey
    });
  }, [allowFailure, blockNumber, cacheOnBlock, chainId, scopeKey, contracts, overrides]);
  var enabled = React18.useMemo(function () {
    var enabled2 = Boolean(enabled_ && (contracts === null || contracts === void 0 ? void 0 : contracts.every(function (x) {
      return x.abi && x.address && x.functionName;
    })));
    if (cacheOnBlock) enabled2 = Boolean(enabled2 && blockNumber);
    return enabled2;
  }, [blockNumber, cacheOnBlock, contracts, enabled_]);
  useInvalidateOnBlock({
    enabled: Boolean(enabled && watch && !cacheOnBlock),
    queryKey: queryKey_
  });
  var abis = (contracts !== null && contracts !== void 0 ? contracts : []).map(function (_ref47) {
    var abi = _ref47.abi;
    return abi;
  });
  return useQuery(queryKey_, queryFn7({
    abis: abis
  }), {
    cacheTime: cacheTime,
    enabled: enabled,
    isDataEqual: isDataEqual,
    keepPreviousData: keepPreviousData,
    staleTime: staleTime,
    select: function select(data) {
      var result = data.map(function (data2, i) {
        var _contracts$i;

        var _ref48 = (_contracts$i = contracts === null || contracts === void 0 ? void 0 : contracts[i]) !== null && _contracts$i !== void 0 ? _contracts$i : {},
            abi = _ref48.abi,
            functionName = _ref48.functionName;

        return abi && functionName ? parseContractResult2({
          abi: abi,
          functionName: functionName,
          data: data2
        }) : data2;
      });
      return _select2 ? _select2(result) : result;
    },
    structuralSharing: structuralSharing,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/contracts/useContractWrite.ts


import { writeContract } from "@wagmi/core";
import * as React19 from "react";

function mutationKey6(_ref49) {
  var address = _ref49.address,
      chainId = _ref49.chainId,
      abi = _ref49.abi,
      functionName = _ref49.functionName,
      config = _objectWithoutProperties(_ref49, _excluded2);

  var request = config.request;
  var args = config.args,
      overrides = config.overrides;
  return [{
    entity: "writeContract",
    address: address,
    args: args,
    chainId: chainId,
    abi: abi,
    functionName: functionName,
    overrides: overrides,
    request: request
  }];
}

function mutationFn6(config) {
  if (!config.address) throw new Error("address is required");
  if (!config.abi) throw new Error("abi is required");
  if (!config.functionName) throw new Error("functionName is required");

  switch (config.mode) {
    case "prepared":
      {
        if (!config.request) throw new Error("request is required");
        return writeContract({
          mode: "prepared",
          address: config.address,
          chainId: config.chainId,
          abi: config.abi,
          functionName: config.functionName,
          request: config.request
        });
      }

    case "recklesslyUnprepared":
      return writeContract({
        address: config.address,
        args: config.args,
        chainId: config.chainId,
        abi: config.abi,
        functionName: config.functionName,
        mode: "recklesslyUnprepared",
        overrides: config.overrides
      });
  }
}

function useContractWrite() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var address = config.address,
      abi = config.abi,
      functionName = config.functionName,
      chainId = config.chainId,
      mode = config.mode;
  var request = config.request;
  var args = config.args,
      overrides = config.overrides;

  var _useMutation6 = useMutation(mutationKey6({
    address: address,
    abi: abi,
    functionName: functionName,
    chainId: chainId,
    mode: mode,
    args: args,
    overrides: overrides,
    request: request
  }), mutationFn6, {
    onError: config.onError,
    onMutate: config.onMutate,
    onSettled: config.onSettled,
    onSuccess: config.onSuccess
  }),
      data = _useMutation6.data,
      error = _useMutation6.error,
      isError = _useMutation6.isError,
      isIdle = _useMutation6.isIdle,
      isLoading = _useMutation6.isLoading,
      isSuccess = _useMutation6.isSuccess,
      mutate = _useMutation6.mutate,
      mutateAsync = _useMutation6.mutateAsync,
      reset = _useMutation6.reset,
      status = _useMutation6.status,
      variables = _useMutation6.variables;

  var write = React19.useMemo(function () {
    if (mode === "prepared") {
      if (!request) return void 0;
      return function () {
        return mutate({
          address: address,
          chainId: chainId,
          abi: abi,
          functionName: functionName,
          mode: "prepared",
          request: request
        });
      };
    }

    return function (overrideConfig) {
      var _overrideConfig$reckl, _overrideConfig$reckl2;

      return mutate({
        address: address,
        args: (_overrideConfig$reckl = overrideConfig === null || overrideConfig === void 0 ? void 0 : overrideConfig.recklesslySetUnpreparedArgs) !== null && _overrideConfig$reckl !== void 0 ? _overrideConfig$reckl : args,
        chainId: chainId,
        abi: abi,
        functionName: functionName,
        mode: "recklesslyUnprepared",
        overrides: (_overrideConfig$reckl2 = overrideConfig === null || overrideConfig === void 0 ? void 0 : overrideConfig.recklesslySetUnpreparedOverrides) !== null && _overrideConfig$reckl2 !== void 0 ? _overrideConfig$reckl2 : overrides
      });
    };
  }, [address, chainId, abi, functionName, mode, mutate, args, overrides, request]);
  var writeAsync = React19.useMemo(function () {
    if (mode === "prepared") {
      if (!request) return void 0;
      return function () {
        return mutateAsync({
          address: address,
          chainId: chainId,
          abi: abi,
          functionName: functionName,
          mode: "prepared",
          request: request
        });
      };
    }

    return function (overrideConfig) {
      var _overrideConfig$reckl3, _overrideConfig$reckl4;

      return mutateAsync({
        address: address,
        args: (_overrideConfig$reckl3 = overrideConfig === null || overrideConfig === void 0 ? void 0 : overrideConfig.recklesslySetUnpreparedArgs) !== null && _overrideConfig$reckl3 !== void 0 ? _overrideConfig$reckl3 : args,
        chainId: chainId,
        abi: abi,
        functionName: functionName,
        mode: "recklesslyUnprepared",
        overrides: (_overrideConfig$reckl4 = overrideConfig === null || overrideConfig === void 0 ? void 0 : overrideConfig.recklesslySetUnpreparedOverrides) !== null && _overrideConfig$reckl4 !== void 0 ? _overrideConfig$reckl4 : overrides
      });
    };
  }, [address, chainId, abi, functionName, mode, mutateAsync, args, overrides, request]);
  return {
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    status: status,
    variables: variables,
    write: write,
    writeAsync: writeAsync
  };
} // src/hooks/contracts/usePrepareContractWrite.ts


import { prepareWriteContract } from "@wagmi/core";

function queryKey8(_ref50) {
  var activeChainId = _ref50.activeChainId,
      args = _ref50.args,
      address = _ref50.address,
      chainId = _ref50.chainId,
      functionName = _ref50.functionName,
      overrides = _ref50.overrides,
      signerAddress = _ref50.signerAddress;
  return [{
    entity: "prepareContractTransaction",
    activeChainId: activeChainId,
    address: address,
    args: args,
    chainId: chainId,
    functionName: functionName,
    overrides: overrides,
    signerAddress: signerAddress
  }];
}

function queryFn8(_ref51) {
  var abi = _ref51.abi,
      signer = _ref51.signer;
  return function (_ref52) {
    var _ref52$queryKey = _slicedToArray(_ref52.queryKey, 1),
        _ref52$queryKey$ = _ref52$queryKey[0],
        args = _ref52$queryKey$.args,
        address = _ref52$queryKey$.address,
        chainId = _ref52$queryKey$.chainId,
        functionName = _ref52$queryKey$.functionName,
        overrides = _ref52$queryKey$.overrides;

    if (!abi) throw new Error("abi is required");
    return prepareWriteContract({
      abi: abi,
      args: args,
      address: address,
      chainId: chainId,
      functionName: functionName,
      overrides: overrides,
      signer: signer
    });
  };
}

function usePrepareContractWrite() {
  var _ref53 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref53.address,
      abi = _ref53.abi,
      functionName = _ref53.functionName,
      chainId = _ref53.chainId,
      args = _ref53.args,
      overrides = _ref53.overrides,
      cacheTime = _ref53.cacheTime,
      _ref53$enabled = _ref53.enabled,
      enabled = _ref53$enabled === void 0 ? true : _ref53$enabled,
      scopeKey = _ref53.scopeKey,
      staleTime = _ref53.staleTime,
      suspense = _ref53.suspense,
      onError = _ref53.onError,
      onSettled = _ref53.onSettled,
      onSuccess = _ref53.onSuccess;

  var _useNetwork = useNetwork(),
      activeChain = _useNetwork.chain;

  var _useSigner = useSigner({
    chainId: chainId
  }),
      signer = _useSigner.data;

  var prepareContractWriteQuery = useQuery(queryKey8({
    activeChainId: activeChain === null || activeChain === void 0 ? void 0 : activeChain.id,
    address: address,
    args: args,
    chainId: chainId,
    functionName: functionName,
    scopeKey: scopeKey,
    signerAddress: signer === null || signer === void 0 ? void 0 : signer._address,
    overrides: overrides
  }), queryFn8({
    abi: abi,
    signer: signer
  }), {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && abi && address && functionName && signer),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
  return Object.assign(prepareContractWriteQuery, {
    config: _objectSpread({
      abi: abi,
      address: address,
      args: args,
      chainId: chainId,
      functionName: functionName,
      mode: "prepared",
      overrides: overrides,
      request: void 0
    }, prepareContractWriteQuery.data)
  });
} // src/hooks/contracts/useToken.ts


import { fetchToken } from "@wagmi/core";

function queryKey9(_ref54) {
  var address = _ref54.address,
      chainId = _ref54.chainId,
      formatUnits = _ref54.formatUnits,
      scopeKey = _ref54.scopeKey;
  return [{
    entity: "token",
    address: address,
    chainId: chainId,
    formatUnits: formatUnits,
    scopeKey: scopeKey
  }];
}

function queryFn9(_ref55) {
  var _ref55$queryKey = _slicedToArray(_ref55.queryKey, 1),
      _ref55$queryKey$ = _ref55$queryKey[0],
      address = _ref55$queryKey$.address,
      chainId = _ref55$queryKey$.chainId,
      formatUnits = _ref55$queryKey$.formatUnits;

  if (!address) throw new Error("address is required");
  return fetchToken({
    address: address,
    chainId: chainId,
    formatUnits: formatUnits
  });
}

function useToken() {
  var _ref56 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref56.address,
      chainId_ = _ref56.chainId,
      _ref56$formatUnits = _ref56.formatUnits,
      formatUnits = _ref56$formatUnits === void 0 ? "ether" : _ref56$formatUnits,
      cacheTime = _ref56.cacheTime,
      _ref56$enabled = _ref56.enabled,
      enabled = _ref56$enabled === void 0 ? true : _ref56$enabled,
      scopeKey = _ref56.scopeKey,
      _ref56$staleTime = _ref56.staleTime,
      staleTime = _ref56$staleTime === void 0 ? 1e3 * 60 * 60 * 24 : _ref56$staleTime,
      suspense = _ref56.suspense,
      onError = _ref56.onError,
      onSettled = _ref56.onSettled,
      onSuccess = _ref56.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey9({
    address: address,
    chainId: chainId,
    formatUnits: formatUnits,
    scopeKey: scopeKey
  }), queryFn9, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && address),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/ens/useEnsAddress.ts


import { fetchEnsAddress } from "@wagmi/core";

function queryKey10(_ref57) {
  var chainId = _ref57.chainId,
      name = _ref57.name,
      scopeKey = _ref57.scopeKey;
  return [{
    entity: "ensAddress",
    chainId: chainId,
    name: name,
    scopeKey: scopeKey
  }];
}

function queryFn10(_ref58) {
  var _ref58$queryKey = _slicedToArray(_ref58.queryKey, 1),
      _ref58$queryKey$ = _ref58$queryKey[0],
      chainId = _ref58$queryKey$.chainId,
      name = _ref58$queryKey$.name;

  if (!name) throw new Error("name is required");
  return fetchEnsAddress({
    chainId: chainId,
    name: name
  });
}

function useEnsAddress() {
  var _ref59 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      cacheTime = _ref59.cacheTime,
      chainId_ = _ref59.chainId,
      _ref59$enabled = _ref59.enabled,
      enabled = _ref59$enabled === void 0 ? true : _ref59$enabled,
      name = _ref59.name,
      scopeKey = _ref59.scopeKey,
      _ref59$staleTime = _ref59.staleTime,
      staleTime = _ref59$staleTime === void 0 ? 1e3 * 60 * 60 * 24 : _ref59$staleTime,
      suspense = _ref59.suspense,
      onError = _ref59.onError,
      onSettled = _ref59.onSettled,
      onSuccess = _ref59.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey10({
    chainId: chainId,
    name: name,
    scopeKey: scopeKey
  }), queryFn10, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && chainId && name),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/ens/useEnsAvatar.ts


import { fetchEnsAvatar } from "@wagmi/core";

function queryKey11(_ref60) {
  var address = _ref60.address,
      chainId = _ref60.chainId,
      scopeKey = _ref60.scopeKey;
  return [{
    entity: "ensAvatar",
    address: address,
    chainId: chainId,
    scopeKey: scopeKey
  }];
}

function queryFn11(_ref61) {
  var _ref61$queryKey = _slicedToArray(_ref61.queryKey, 1),
      _ref61$queryKey$ = _ref61$queryKey[0],
      address = _ref61$queryKey$.address,
      chainId = _ref61$queryKey$.chainId;

  if (!address) throw new Error("address is required");
  return fetchEnsAvatar({
    address: address,
    chainId: chainId
  });
}

function useEnsAvatar() {
  var _ref62 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref62.address,
      cacheTime = _ref62.cacheTime,
      chainId_ = _ref62.chainId,
      _ref62$enabled = _ref62.enabled,
      enabled = _ref62$enabled === void 0 ? true : _ref62$enabled,
      scopeKey = _ref62.scopeKey,
      _ref62$staleTime = _ref62.staleTime,
      staleTime = _ref62$staleTime === void 0 ? 1e3 * 60 * 60 * 24 : _ref62$staleTime,
      suspense = _ref62.suspense,
      onError = _ref62.onError,
      onSettled = _ref62.onSettled,
      onSuccess = _ref62.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey11({
    address: address,
    chainId: chainId,
    scopeKey: scopeKey
  }), queryFn11, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && address && chainId),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/ens/useEnsName.ts


import { fetchEnsName } from "@wagmi/core";

function queryKey12(_ref63) {
  var address = _ref63.address,
      chainId = _ref63.chainId,
      scopeKey = _ref63.scopeKey;
  return [{
    entity: "ensName",
    address: address,
    chainId: chainId,
    scopeKey: scopeKey
  }];
}

function queryFn12(_ref64) {
  var _ref64$queryKey = _slicedToArray(_ref64.queryKey, 1),
      _ref64$queryKey$ = _ref64$queryKey[0],
      address = _ref64$queryKey$.address,
      chainId = _ref64$queryKey$.chainId;

  if (!address) throw new Error("address is required");
  return fetchEnsName({
    address: address,
    chainId: chainId
  });
}

function useEnsName() {
  var _ref65 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      address = _ref65.address,
      cacheTime = _ref65.cacheTime,
      chainId_ = _ref65.chainId,
      _ref65$enabled = _ref65.enabled,
      enabled = _ref65$enabled === void 0 ? true : _ref65$enabled,
      scopeKey = _ref65.scopeKey,
      _ref65$staleTime = _ref65.staleTime,
      staleTime = _ref65$staleTime === void 0 ? 1e3 * 60 * 60 * 24 : _ref65$staleTime,
      suspense = _ref65.suspense,
      onError = _ref65.onError,
      onSettled = _ref65.onSettled,
      onSuccess = _ref65.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey12({
    address: address,
    chainId: chainId,
    scopeKey: scopeKey
  }), queryFn12, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && address && chainId),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/ens/useEnsResolver.ts


import { fetchEnsResolver } from "@wagmi/core";

function queryKey13(_ref66) {
  var chainId = _ref66.chainId,
      name = _ref66.name,
      scopeKey = _ref66.scopeKey;
  return [{
    entity: "ensResolver",
    chainId: chainId,
    name: name,
    scopeKey: scopeKey,
    persist: false
  }];
}

function queryFn13(_ref67) {
  var _ref67$queryKey = _slicedToArray(_ref67.queryKey, 1),
      _ref67$queryKey$ = _ref67$queryKey[0],
      chainId = _ref67$queryKey$.chainId,
      name = _ref67$queryKey$.name;

  if (!name) throw new Error("name is required");
  return fetchEnsResolver({
    chainId: chainId,
    name: name
  });
}

function useEnsResolver() {
  var _ref68 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId_ = _ref68.chainId,
      name = _ref68.name,
      _ref68$enabled = _ref68.enabled,
      enabled = _ref68$enabled === void 0 ? true : _ref68$enabled,
      scopeKey = _ref68.scopeKey,
      suspense = _ref68.suspense,
      onError = _ref68.onError,
      onSettled = _ref68.onSettled,
      onSuccess = _ref68.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey13({
    chainId: chainId,
    name: name,
    scopeKey: scopeKey
  }), queryFn13, {
    cacheTime: 0,
    enabled: Boolean(enabled && chainId && name),
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/transactions/usePrepareSendTransaction.ts


import { prepareSendTransaction } from "@wagmi/core";

function queryKey14(_ref69) {
  var activeChainId = _ref69.activeChainId,
      chainId = _ref69.chainId,
      request = _ref69.request,
      scopeKey = _ref69.scopeKey,
      signerAddress = _ref69.signerAddress;
  return [{
    entity: "prepareSendTransaction",
    activeChainId: activeChainId,
    chainId: chainId,
    request: request,
    scopeKey: scopeKey,
    signerAddress: signerAddress
  }];
}

function queryFn14(_ref70) {
  var signer = _ref70.signer;
  return function (_ref71) {
    var _ref71$queryKey = _slicedToArray(_ref71.queryKey, 1),
        _ref71$queryKey$ = _ref71$queryKey[0],
        chainId = _ref71$queryKey$.chainId,
        request = _ref71$queryKey$.request;

    if (!(request === null || request === void 0 ? void 0 : request.to)) throw new Error("request.to is required");
    return prepareSendTransaction({
      chainId: chainId,
      request: _objectSpread(_objectSpread({}, request), {}, {
        to: request.to
      }),
      signer: signer
    });
  };
}

function usePrepareSendTransaction() {
  var _ref72 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId = _ref72.chainId,
      request = _ref72.request,
      cacheTime = _ref72.cacheTime,
      _ref72$enabled = _ref72.enabled,
      enabled = _ref72$enabled === void 0 ? true : _ref72$enabled,
      scopeKey = _ref72.scopeKey,
      _ref72$staleTime = _ref72.staleTime,
      staleTime = _ref72$staleTime === void 0 ? 1e3 * 60 * 60 * 24 : _ref72$staleTime,
      suspense = _ref72.suspense,
      onError = _ref72.onError,
      onSettled = _ref72.onSettled,
      onSuccess = _ref72.onSuccess;

  var _useNetwork2 = useNetwork(),
      activeChain = _useNetwork2.chain;

  var _useSigner2 = useSigner({
    chainId: chainId
  }),
      signer = _useSigner2.data;

  var prepareSendTransactionQuery = useQuery(queryKey14({
    activeChainId: activeChain === null || activeChain === void 0 ? void 0 : activeChain.id,
    chainId: chainId,
    request: request,
    scopeKey: scopeKey,
    signerAddress: signer === null || signer === void 0 ? void 0 : signer._address
  }), queryFn14({
    signer: signer
  }), {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && signer && request && request.to),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
  return Object.assign(prepareSendTransactionQuery, {
    config: _objectSpread({
      request: void 0,
      mode: "prepared"
    }, prepareSendTransactionQuery.data)
  });
} // src/hooks/transactions/useSendTransaction.ts


import { sendTransaction } from "@wagmi/core";
import * as React20 from "react";

var mutationKey7 = function mutationKey7(args) {
  return [_objectSpread({
    entity: "sendTransaction"
  }, args)];
};

var mutationFn7 = function mutationFn7(_ref73) {
  var chainId = _ref73.chainId,
      mode = _ref73.mode,
      request = _ref73.request;
  return sendTransaction({
    chainId: chainId,
    mode: mode,
    request: request
  });
};

function useSendTransaction(_ref74) {
  var chainId = _ref74.chainId,
      mode = _ref74.mode,
      request = _ref74.request,
      onError = _ref74.onError,
      onMutate = _ref74.onMutate,
      onSettled = _ref74.onSettled,
      onSuccess = _ref74.onSuccess;

  var _useMutation7 = useMutation(mutationKey7({
    chainId: chainId,
    mode: mode,
    request: request
  }), mutationFn7, {
    onError: onError,
    onMutate: onMutate,
    onSettled: onSettled,
    onSuccess: onSuccess
  }),
      data = _useMutation7.data,
      error = _useMutation7.error,
      isError = _useMutation7.isError,
      isIdle = _useMutation7.isIdle,
      isLoading = _useMutation7.isLoading,
      isSuccess = _useMutation7.isSuccess,
      mutate = _useMutation7.mutate,
      mutateAsync = _useMutation7.mutateAsync,
      reset = _useMutation7.reset,
      status = _useMutation7.status,
      variables = _useMutation7.variables;

  var sendTransaction2 = React20.useCallback(function (args) {
    var _args$recklesslySetUn;

    return mutate({
      chainId: chainId,
      mode: mode,
      request: (_args$recklesslySetUn = args === null || args === void 0 ? void 0 : args.recklesslySetUnpreparedRequest) !== null && _args$recklesslySetUn !== void 0 ? _args$recklesslySetUn : request
    });
  }, [chainId, mode, mutate, request]);
  var sendTransactionAsync = React20.useCallback(function (args) {
    var _args$recklesslySetUn2;

    return mutateAsync({
      chainId: chainId,
      mode: mode,
      request: (_args$recklesslySetUn2 = args === null || args === void 0 ? void 0 : args.recklesslySetUnpreparedRequest) !== null && _args$recklesslySetUn2 !== void 0 ? _args$recklesslySetUn2 : request
    });
  }, [chainId, mode, mutateAsync, request]);
  return {
    data: data,
    error: error,
    isError: isError,
    isIdle: isIdle,
    isLoading: isLoading,
    isSuccess: isSuccess,
    reset: reset,
    sendTransaction: mode === "prepared" && !request ? void 0 : sendTransaction2,
    sendTransactionAsync: mode === "prepared" && !request ? void 0 : sendTransactionAsync,
    status: status,
    variables: variables
  };
} // src/hooks/transactions/useTransaction.ts


import { fetchTransaction } from "@wagmi/core";

function queryKey15(_ref75) {
  var chainId = _ref75.chainId,
      hash = _ref75.hash,
      scopeKey = _ref75.scopeKey;
  return [{
    entity: "transaction",
    chainId: chainId,
    hash: hash,
    scopeKey: scopeKey
  }];
}

function queryFn15(_ref76) {
  var _ref76$queryKey = _slicedToArray(_ref76.queryKey, 1),
      _ref76$queryKey$ = _ref76$queryKey[0],
      chainId = _ref76$queryKey$.chainId,
      hash = _ref76$queryKey$.hash;

  if (!hash) throw new Error("hash is required");
  return fetchTransaction({
    chainId: chainId,
    hash: hash
  });
}

function useTransaction() {
  var _ref77 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref77$cacheTime = _ref77.cacheTime,
      cacheTime = _ref77$cacheTime === void 0 ? 0 : _ref77$cacheTime,
      chainId_ = _ref77.chainId,
      _ref77$enabled = _ref77.enabled,
      enabled = _ref77$enabled === void 0 ? true : _ref77$enabled,
      hash = _ref77.hash,
      scopeKey = _ref77.scopeKey,
      staleTime = _ref77.staleTime,
      suspense = _ref77.suspense,
      onError = _ref77.onError,
      onSettled = _ref77.onSettled,
      onSuccess = _ref77.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey15({
    chainId: chainId,
    hash: hash,
    scopeKey: scopeKey
  }), queryFn15, {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && hash),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/transactions/useWaitForTransaction.ts


import { waitForTransaction } from "@wagmi/core";

function queryKey16(_ref78) {
  var confirmations = _ref78.confirmations,
      chainId = _ref78.chainId,
      hash = _ref78.hash,
      scopeKey = _ref78.scopeKey,
      timeout = _ref78.timeout;
  return [{
    entity: "waitForTransaction",
    confirmations: confirmations,
    chainId: chainId,
    hash: hash,
    scopeKey: scopeKey,
    timeout: timeout
  }];
}

function queryFn16(_ref79) {
  var onSpeedUp = _ref79.onSpeedUp;
  return function (_ref80) {
    var _ref80$queryKey = _slicedToArray(_ref80.queryKey, 1),
        _ref80$queryKey$ = _ref80$queryKey[0],
        chainId = _ref80$queryKey$.chainId,
        confirmations = _ref80$queryKey$.confirmations,
        hash = _ref80$queryKey$.hash,
        timeout = _ref80$queryKey$.timeout;

    if (!hash) throw new Error("hash is required");
    return waitForTransaction({
      chainId: chainId,
      confirmations: confirmations,
      hash: hash,
      onSpeedUp: onSpeedUp,
      timeout: timeout
    });
  };
}

function useWaitForTransaction() {
  var _ref81 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      chainId_ = _ref81.chainId,
      confirmations = _ref81.confirmations,
      hash = _ref81.hash,
      timeout = _ref81.timeout,
      cacheTime = _ref81.cacheTime,
      _ref81$enabled = _ref81.enabled,
      enabled = _ref81$enabled === void 0 ? true : _ref81$enabled,
      scopeKey = _ref81.scopeKey,
      staleTime = _ref81.staleTime,
      suspense = _ref81.suspense,
      onError = _ref81.onError,
      onSpeedUp = _ref81.onSpeedUp,
      onSettled = _ref81.onSettled,
      onSuccess = _ref81.onSuccess;

  var chainId = useChainId({
    chainId: chainId_
  });
  return useQuery(queryKey16({
    chainId: chainId,
    confirmations: confirmations,
    hash: hash,
    scopeKey: scopeKey,
    timeout: timeout
  }), queryFn16({
    onSpeedUp: onSpeedUp
  }), {
    cacheTime: cacheTime,
    enabled: Boolean(enabled && hash),
    staleTime: staleTime,
    suspense: suspense,
    onError: onError,
    onSettled: onSettled,
    onSuccess: onSuccess
  });
} // src/hooks/transactions/useWatchPendingTransactions.ts


import * as React21 from "react";

function useWatchPendingTransactions(_ref82) {
  var chainId_ = _ref82.chainId,
      _ref82$enabled = _ref82.enabled,
      enabled = _ref82$enabled === void 0 ? true : _ref82$enabled,
      listener = _ref82.listener;
  var chainId = useChainId({
    chainId: chainId_
  });
  var provider = useProvider({
    chainId: chainId
  });
  var webSocketProvider = useWebSocketProvider({
    chainId: chainId
  });
  React21.useEffect(function () {
    if (!enabled) return;
    var provider_ = webSocketProvider !== null && webSocketProvider !== void 0 ? webSocketProvider : provider;
    provider_.on("pending", listener);
    return function () {
      provider_.off("pending", listener);
    };
  }, [enabled, listener, provider, webSocketProvider]);
} // src/index.ts


import { AddChainError, ChainDoesNotSupportMulticallError, ChainMismatchError, ChainNotConfiguredError, Connector, ConnectorAlreadyConnectedError, ConnectorNotFoundError, ContractMethodDoesNotExistError, ContractMethodNoResultError, ContractMethodRevertedError, ContractResultDecodeError, ProviderChainsNotFound, ProviderRpcError, ResourceUnavailableError, RpcError, SwitchChainError, SwitchChainNotSupportedError, UserRejectedRequestError, configureChains, createStorage as createStorage2, deepEqual as deepEqual5, deserialize, erc20ABI, erc721ABI, erc4626ABI, goerli, mainnet, readContracts as readContracts3, sepolia, serialize } from "@wagmi/core";
export { AddChainError, ChainDoesNotSupportMulticallError, ChainMismatchError, ChainNotConfiguredError, Connector, ConnectorAlreadyConnectedError, ConnectorNotFoundError, Context, ContractMethodDoesNotExistError, ContractMethodNoResultError, ContractMethodRevertedError, ContractResultDecodeError, ProviderChainsNotFound, ProviderRpcError, ResourceUnavailableError, RpcError, SwitchChainError, SwitchChainNotSupportedError, UserRejectedRequestError, WagmiConfig, configureChains, createClient, createStorage2 as createStorage, deepEqual5 as deepEqual, deserialize, erc20ABI, erc4626ABI, erc721ABI, goerli, mainnet, paginatedIndexesConfig, readContracts3 as readContracts, sepolia, serialize, useAccount, useBalance, useBlockNumber, useChainId, useClient, useConnect, useContract, useContractEvent, useContractInfiniteReads, useContractRead, useContractReads, useContractWrite, useDisconnect, useEnsAddress, useEnsAvatar, useEnsName, useEnsResolver, useFeeData, useInfiniteQuery, useMutation, useNetwork, usePrepareContractWrite, usePrepareSendTransaction, useProvider, useQuery, useQueryClient2 as useQueryClient, useSendTransaction, useSignMessage, useSignTypedData, useSigner, useSwitchNetwork, useToken, useTransaction, useWaitForTransaction, useWatchPendingTransactions, useWebSocketProvider };